import { Translate } from "../../constant/Translate"

const { TEXT_T712 } = Translate

const BRACKET_MAP = {
  full: ["（", "）"],
  half: ["(", ")"],
} as const

export const combineWithBracket = (
  value1: string,
  value2: string,
  type: "full" | "half" = "full",
): string => {
  const [open, close] = BRACKET_MAP[type]

  return value1 && value2 ? `${value1}${open}${value2}${close}` : TEXT_T712
}
